const API_URL = '/api';

// Detecta se o termo é CPF (11 dígitos) ou placa (alfanumérico, 6-8 chars).
export function detectarTipoBusca(termo) {
  const alfanum = String(termo || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  if (/^\d{11}$/.test(alfanum)) return { tipo: 'cpf', valor: alfanum };
  if (/^[A-Z0-9]{6,8}$/.test(alfanum)) return { tipo: 'placa', valor: alfanum };
  return { tipo: 'desconhecido', valor: alfanum };
}

export async function buscarDadosAtendimento(apiFetch, termo) {
  const { tipo, valor } = detectarTipoBusca(termo);

  if (tipo === 'desconhecido') {
    throw new Error('Informe um CPF (11 dígitos) ou uma placa (6 a 8 caracteres).');
  }

  const urlBusca =
    tipo === 'cpf'
      ? `${API_URL}/associados/buscar/${valor}`
      : `${API_URL}/associados/buscar-placa/${valor}`;

  const responseAssoc = await apiFetch(urlBusca);

  if (!responseAssoc.ok) {
    const data = await responseAssoc.json();
    throw new Error(data.error || 'Erro ao buscar associado');
  }

  const associado = await responseAssoc.json();
  const cpfDoAssociado = associado.cpf;

  let situacaoFinanceira = null;
  let boletosPendentes = null;

  if (cpfDoAssociado) {
    const responseSituacao = await apiFetch(`${API_URL}/boletos/situacao/${cpfDoAssociado}`);

    if (responseSituacao.ok) {
      situacaoFinanceira = await responseSituacao.json();

      if (situacaoFinanceira.temBoletoAberto) {
        const responseBoletos = await apiFetch(`${API_URL}/boletos/pendentes/${cpfDoAssociado}`);

        if (responseBoletos.ok) {
          boletosPendentes = await responseBoletos.json();
        }
      }
    }
  }

  return {
    associado,
    situacaoFinanceira,
    boletosPendentes,
  };
}
